module.exports = __webpack_public_path__ + "static/media/recommended.0f82767b.png";